<template>
  <div class="content-wrapper">
    <section class="content-customers pt-5">
      <div class="container">
        <h2>Resources</h2>
        <table class="table ">
          <thead>
            <tr>
              <th>Name</th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Example report</td>
              <td>An example of the final report</td>
              <td class="text-right">
                <a href="#">Download</a>
              </td>
            </tr>
            <tr>
              <td>Demo portal</td>
              <td>An example of the Microba portal</td>
              <td class="text-right">
                <a href="#">View details</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!-- /CONTAINER -->
    </section>
  </div>
</template>

<script>
  // @ is an alias to /src
export default {
  name: 'Patients',
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>
